import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const MANAGEMENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ManagementType.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const MANAGEMENTTYPE_CONFIG = {
  entityName: 'ManagementType',
  localizationKey: 'Planning::Entity.ManagementType',
  fields: MANAGEMENTTYPE_FIELDS,
  permission: 'Planning.ManagementTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
